<!--
 * @Description: 电子合同
-->
<template>
  <div class="elec-contract">
    <van-nav-bar left-text="返回"
			:title="$route.meta.title"
			@click-left="$comm.onClickLeft"
			left-arrow
			fixed>
			<template #left>
				<span class="iconfont iconshang comm-rotate-270"></span>
				<span class="comm-return">返回</span>
			</template>
		</van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <div class="tab-content">
      <div class="invoice-list">
        <van-checkbox-group v-model="downResult" ref="downGroup">
          <div v-for="(down, i) in downList"
            :key="i">
            <div class="comm-seperator"></div>
            <elec-item :item="down"
              @changecheck="changeCheckDown"></elec-item>
          </div>
        </van-checkbox-group>
      </div>
      <van-row v-if="false" class="apply-bar">
        <van-col span="5"
          class="bar-txt">
          <van-checkbox v-model="downAllChecked"
            @click="downAllCheck"
            checked-color="#1677FF"
            icon-size="16px">
            全选
          </van-checkbox>
        </van-col>
        <van-col span="5"
          class="bar-txt">共:
          <span style="color:#2C82C9;">{{downList.length}}</span>&nbsp;笔
        </van-col>
        <van-col span="5"
          class="bar-txt">
          选择&nbsp;<span style="color:#2C82C9;">{{downResult.length}}</span>&nbsp;笔
        </van-col>
        <van-col span="9">
          <van-button @click="downClick()"
            class="apply-btn"
            type="info">
            发票下载
          </van-button>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import elecItem from "./elecItem";
export default {
  components: {
    elecItem
  },
  data() {
    return {
      downList:[
        {
          pid:'0',
          fpny:'1',
          yhh:'2',
          yhmc:'3',
          ysdz:'4',
          fpje:'5'
        }
      ],
      downResult: [],
      downAllChecked: false,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList(){
      this.$http
				.post(this.$api.getContract, {})
				.then(res => {
					if (res.code === "000") {
						this.downList = res.data;
					} else {
						this.$toast(res.msg);
					}
				});
    },
    changeCheckDown(item) {
			this.downList[this.downList.findIndex(e => e.pid == item.pid)].active = !this
				.downList[this.downList.findIndex(e => e.pid == item.pid)].active;
			this.downAllChecked =
				this.downList.filter(e => e.active == true).length == this.downList.length;
    },
    downClick() {}
  },
}
</script>

<style lang="less" scoped>
.elec-contract{
  .tab-content {
		.invoice-list {
			margin: 0 3%;
			margin-top: 10px;
			border-radius: 5px;
		}
		.apply-bar {
			height: 44px;
			position: fixed;
			bottom: 0;
			width: 100%;
			padding: 0 16px;
			background: rgba(255, 255, 255, 1);
			display: flex;
			justify-content: space-between;
			align-items: center;
			.bar-txt {
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(33, 33, 33, 1);
			}
			.apply-btn {
				height: 30px;
				background: #2C82C9;
				border-radius: 3px;
				border-color: #2C82C9;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(255, 255, 255, 1);
			}
		}
	}
}
</style>